import { Grid } from '@material-ui/core';
import React from 'react';
import FancySelectButton from './FancySelectButton';

/**
 * Use the same datastructure here as we would in PriceRuleSelect
 * [{id:..., name:....},....]
 */
function FancyButtongroupSelect({ options, value, setValue, label }) {
    return (
        <Grid item container className="golf-options" justifyContent="flex-start">
            <Grid item container spacing={1}>
                {options.map((val, index) => (
                    <Grid
                        key={val.id}
                        item
                        xs={6}
                        container
                        justifyContent={index % 2 === 0 ? 'flex-end' : 'flex-start'}
                        alignItems="center"
                    >
                        <Grid item>
                            {index <= 1 && <p>{index === 0 ? label : '\u00a0'}</p>}
                            <FancySelectButton
                                highlight={val.id === value}
                                onClick={() => setValue(val.id)}
                                label={val.name}
                            />
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        </Grid>
    );
}

export default FancyButtongroupSelect;
